<template>
    <div>
        <Headers v-if="!$isMobileDevice" />
        <app-main ref="appMain" />
        <Footer v-if="!$isMobileDevice" />
    </div>
</template>
<script>
import { Headers, AppMain, Footer } from './components';
export default {
    name: 'LayoutBox',
    components: {
        Headers,
        AppMain,
        Footer
    },
    data() {
        return {};
    }
};
</script>
